export default "__VITE_ASSET__C_ib8ozM__"